export function isFunction(v) {
  return typeof v === 'function';
}
